'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { XIcon } from 'lucide-react';
import * as React from 'react';
import type { Option } from './multiselect';
interface ItemRendererProps {
  option: Option;
  badgeClassName?: string;
  disabled?: boolean;
  onUnselect: (option: Option) => void;
}
function ItemRenderer(t0) {
  const $ = _c(22);
  const {
    option,
    badgeClassName,
    disabled,
    onUnselect
  } = t0;
  const t1 = option.value;
  let t2;
  if ($[0] !== badgeClassName) {
    t2 = cn("animate-fadeIn bg-background text-secondary-foreground hover:bg-background relative inline-flex h-7 shrink-0 cursor-default items-center rounded-md border ps-2 pe-7 pl-2 text-xs font-medium transition-all disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 data-fixed:pe-2", badgeClassName);
    $[0] = badgeClassName;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = option.fixed;
  const t4 = disabled ?? undefined;
  const t5 = option.label;
  let t6;
  if ($[2] !== option.fixed) {
    t6 = cn("text-muted-foreground/80 hover:text-foreground focus-visible:border-ring focus-visible:ring-ring/50 absolute -inset-y-px -end-px flex size-7 cursor-pointer items-center justify-center rounded-e-md border border-transparent p-0 outline-hidden transition-[color,box-shadow] outline-none focus-visible:ring-[3px]", {
      hidden: option.fixed
    });
    $[2] = option.fixed;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== onUnselect || $[5] !== option) {
    t7 = e => {
      if (e.key === "Enter" && !option.fixed) {
        e.preventDefault();
        e.stopPropagation();
        onUnselect(option);
      }
    };
    $[4] = onUnselect;
    $[5] = option;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== onUnselect || $[8] !== option) {
    t8 = e_1 => {
      e_1.preventDefault();
      e_1.stopPropagation();
      if (!option.fixed) {
        onUnselect(option);
      }
    };
    $[7] = onUnselect;
    $[8] = option;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <XIcon size={14} aria-hidden="true" />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t6 || $[12] !== t7 || $[13] !== t8) {
    t10 = <div className={t6} onKeyDown={t7} onMouseDown={_temp} onClick={t8} role="button" tabIndex={0} aria-label="Remove">{t9}</div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== option.fixed || $[16] !== option.label || $[17] !== option.value || $[18] !== t10 || $[19] !== t2 || $[20] !== t4) {
    t11 = <div key={t1} className={t2} data-fixed={t3} data-disabled={t4}>{t5}{t10}</div>;
    $[15] = option.fixed;
    $[16] = option.label;
    $[17] = option.value;
    $[18] = t10;
    $[19] = t2;
    $[20] = t4;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}
function _temp(e_0) {
  e_0.preventDefault();
  e_0.stopPropagation();
}
export { ItemRenderer };